import {useEffect, useRef} from 'react';

// hands back the last non-null value once the current one is gone, so a component fading out can keep
// rendering what it was showing instead of a blank
const useLastDefined = (value) => {
    const lastValueRef = useRef(value);

    useEffect(() => {
        lastValueRef.current = value ?? lastValueRef.current;
    }, [value]);

    return value ?? lastValueRef.current;
};

export default useLastDefined;
